var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[_c('table',{ref:"table",staticClass:"medRecordFieldTable my-3"},_vm._l((_vm.rows),function(row,index){return _c('med-record-update-table-row',{key:'row_'+index,attrs:{"body":row,"index":index,"medRecordTemplateFieldValues":_vm.medRecordTemplateFieldValues},on:{"updated":_vm.rowUpdated}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }